export enum WIDGET_SETTINGS {
    /*
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453878
     */
    AUTOMATIC_OPTION_HELPER = 'WIDGET_SETTINGS_SELECTION_DYNAMIC',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7556600
     */
    AUTOMATIC_OPTION_LABEL = 'FRONT.SETTINGS.SELECTION_LIST',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=415045718
     */
    DISABLED_FOLLOWED_COMMUNITIES_FILTER_HELPER = 'WIDGET_EVENT_LIST.SETTINGS_DISABLED_FOLLOWED_COMMUNITIES_FILTER_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=224896814
     */
    DOUBLE_CLICK_INFO = 'WIDGET_CONTRIBUTION.SETTINGS_DOUBLE_CLICK_INFO',

    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=414643832
     */
    FOLLOWED_COMMUNITIES_ONLY = 'WIDGET_SETTINGS.FOLLOWED_COMMUNITIES_ONLY',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=814381442
     */
    MANUAL_OPTION_HELPER = 'WIDGET_SETTINGS.MANUAL_SELECTION_OPTION_HELPER',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=7556599
     */
    MANUAL_OPTION_LABEL = 'FRONT.SETTINGS.SELECTION_PICK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=821168115
     */
    PREVIEW_NEED_UPDATE_HELPER = 'WIDGET_SETTINGS.PREVIEW_NEED_UPDATE_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=821187166
     */
    PREVIEW_SECTION_HELPER_TEXT = 'WIDGET_SETTINGS.PREVIEW_SECTION_HELPER_TEXT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822219086
     */
    PREVIEW_SECTION_INITIAL_STATE_MESSAGE = 'WIDGET_SETTINGS.PREVIEW_SECTION_INITIAL_STATE_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=821185535
     */
    PREVIEW_SECTION_TITLE = 'WIDGET_SETTINGS.PREVIEW_SECTION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=414583247
     */
    RESTRICTIONS_SECTION_TITLE = 'WIDGET_SETTINGS.RESTRICTIONS_SECTION_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=821157767
     */
    UPDATE_PREVIEW_BUTTON_LABEL = 'WIDGET_SETTINGS.UPDATE_PREVIEW_BUTTON_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=11191556
     */
    VIEW_MODE = 'ADMIN.CUSTOMER.STREAMS.VIEW_MODE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=791475104
     */
    WIDGET_CLEAR_ACTION_LABEL = 'CONTENT_EDITOR.WIDGET_CLEAR_ACTION_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=744766851
     */
    WIDGET_EDITION_MENUBAR_LABEL = 'CONTENT_EDITOR.WIDGET_EDITION_MENUBAR_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=822218653
     */
    WIDGET_LIST_PREVIEW_INFORMATION_MESSAGE = 'WIDGET_SETTINGS.WIDGET_LIST_PREVIEW_INFORMATION_MESSAGE',
}
